/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleDetailOptionState from './state/AccountTitleDetailOptionState'
import AccountTitleDetailEvent from '../../event/AccountTitleDetailEvent'

class AccountTitleDetailOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccountTitleDetailEvent.fetchDetails:
        const details = payload.details.map(detail => {
          return new AccountTitleDetailOptionState().mergeModel(detail)
        })
        return List(details)
      default:
        return state
    }
  }
}

export default new AccountTitleDetailOptionsStore()
